<template>

    <div ref="container" class="d-flex flex-column container">
        <loading ref='loading'></loading>
        <header class="text-center">
            <div class="header-icon header-icon--survey"></div>
            <h1 class="h2">{{ autobrand('translations.client_details') }}</h1>
        </header>

        <div ref="editScroller" class="">

            <local-error v-bind:inline='["user_relationship_type_id", "forenames", "surname", "dob", "gender", "site_id"]'></local-error>

            <form>
                <div class="form-group">
                    <label for='name'>{{ $t('translations.relationship')}} <span class="required-field">*</span></label>
                    <select v-model='item.user_relationship_type_id' class='form-control' >
                        <option disabled value="">{{ $t('translations.please_select')}}</option>
                        <option v-for="(value, key) in $root.lookup.user_relationship_types" :value="key" :key="key">{{ $t('translations.' + value) }}</option>
                    </select>
                    <inline-error type='user_relationship_type_id'></inline-error>
                </div>
                <div class="form-row">
                    <div class="form-group col">
                        <label>{{ $t('translations.first_names')}} <span class="required-field">*</span></label>
                        <input class="form-control" type="text" v-model='item.forenames' >
                        <inline-error type='forenames'></inline-error>
                    </div>

                    <div class="form-group col">
                        <label>{{ $t('translations.surname')}} <span class="required-field">*</span></label>
                        <input class="form-control" type="text" v-model='item.surname' >
                        <inline-error type='surname'></inline-error>
                    </div>
                </div>
                <div class="form-group">
            		<label for='dob'>{{ $t('translations.DOB')}} <span class="required-field">*</span></label>
                    <vue-dob-picker show-labels='true' v-model='item.dob' />
            		<!-- <input type='date' v-model='item.dob' class='form-control'> -->
                    <inline-error type='dob'></inline-error>
            	</div>

                <!-- <div class="form-group">
            		<label for='name'>Gender</label>
            		<select v-model='item.gender' class='form-control' >
                        <option disabled value="">{{$t('translations.please_select')}}</option>
                        <option v-for="(value, key) in $root.lookup.genders" :value="key" :key="key">{{value}}</option>
                    </select>
                    <inline-error type='gender'></inline-error>
            	</div> -->

                <!-- <b-form-group :label="this.$t('translations.gender')">
                    <b-form-radio-group
                        buttons
                        stacked
                        class='btn-block'
                        id="genderSelect"
                        button-variant="card-radio-profile"
                        v-model='item.gender'>

                        <b-form-radio v-for="(value, key) in $root.lookup.genders" :value="key" :key="key">{{ $t(value) }}</b-form-radio>
                    </b-form-radio-group>
                </b-form-group> -->

                <div class="form-group">
            		<label for='gender'>{{ $t('translations.gender')}} <span class="required-field">*</span></label>
            		<select v-model='item.gender' class='form-control' id="gender">
                        <option disabled value="">{{ $t('translations.please_select')}}</option>
                        <option v-for="(value, key) in $root.lookup.genders" :value="key" :key="key">{{$t(value)}}</option>
                    </select>
                    <inline-error type='gender'></inline-error>
            	</div>

                <div v-if='$root.provider && $root.provider.site && $root.provider.site.length > 1' class="form-group">
                    <b-form-group :label="this.$t('translations.preferred_site')">
                    <b-form-radio-group
                              buttons
                              stacked
                              value-field='id'
                              text-field='name'
                              v-model="item.site_id"
                              :options="$root.provider.site"
                              class='btn-block'
                              button-variant="card-radio"
                              name="site_id" />

                    </b-form-group>

                    <inline-error type='site_id'></inline-error>
                </div>

                <!-- <b-form-group label="Usual GP">
                    <b-form-radio-group
                        buttons
                        stacked
                        class='btn-block'
                        id="preferredClinicianSelect"
                        button-variant="primary-outline"
                        v-model='item.preferred_clinician_id'>
                        <b-form-radio v-for="(user) in $root.lookup.staff" :value="user.id" :key="user.id"><span v-text='formatNameCompliant(user)'></span></b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
                <inline-error type='preferred_clinician_id'></inline-error> -->

                <button v-on:click.prevent='createItem' class="btn btn-primary btn-block btn-round mt-2 mb-2">
                    {{ $t('translations.register')}}
                </button>
            </form>
        </div>

    </div>

</template>

<script>
export default {
    props: {
        'route': {default: '/api/vp1/patients'},
        'event': {},
        'model': {},
        'elementname': {},
        'displayelement': {},
        'type': {}
    },
    data: function(){
        return {
            item: {},
            related_data: {},
            errors: [],
        };
    },
    computed: {
        formTitle() {
            if(this.type == "edit") {
                return this.$t('translations.update_your_details');
            }
            else if(this.type == "create") {
                return this.$t('translations.register_for_account');
            }
            else return "&nbsp;"
        }
    },
    mounted() {
        this.errors = [];
        this.resetItem();
    },
    methods: {

        resetItem() {
            this.item = {id: "", site_id: "", forenames: "", surname: "", email: "", dob: "", password: "", password_confirmation: "", gender: "", preferred_clinician_id: ""};
            if(this.$root.provider && this.$root.provider.site && this.$root.provider.site.length == 1) {
                this.item.site_id = this.$root.provider.site[0].id;
            }
            this.errors = [];
        },
        createItem(event) {
            this.setLoading(true);
            axios.post('/api/vp1/patients/registerProxy', this.item).then((res) => {

                if(!this.$route.params.next) {
                    this.$route.params.next = "SelectCaree";
                }

                var params = {};
                if(this.$route.params.action) {
                    params.action = this.$route.params.action;
                    if(this.$route.params.action == "form") {
                         params.action_id = this.$route.params.action_id;
                    }
                }
                this.$root.loadCore(true, {name: this.$route.params.next, params: params});

            }).catch((error) => {
                this.setLoading(false);
                this.handleError(error, "create");
                console.log("this.$refs.editScroller.scrollTop: " + this.$refs.editScroller.scrollTop);
                this.$refs.editScroller.scrollTop = 0;
                console.log("this.$refs.editScroller.scrollTop: " + this.$refs.editScroller.scrollTop);
            });
        },



    }
}
</script>
